import { StyleSheet } from 'react-native';
import { colors } from '../../utils/colors';

export const styles = StyleSheet.create({
	recommendedSlider__card: {
		fontSize: 20,
		width: '100%',
		display: 'flex',
		alignItems: 'center',
		// padding: 20,
		height: 160,
		marginTop: 20,
		marginBottom: 25,
		transition: 'all 0.2s',
	},

	recommendedSlider__view: {},
	recommendedSlider__card__image: {
		width: '100%',
		height: '100%',
	},
	recommendedSlider__card__imageContainer: {
		width: '100%',
		height: 160,
		borderRadius: 20,
		overflow: 'hidden',
		position: 'absolute',
	},
	recommendedSlider__container: {
		display: 'flex',
		width: '100%',
		alignItems: 'center',
	},
	recommendedSlider__overlay: {
		backgroundColor: 'rgba(0,0,0,0.45)',
		zIndex: 1,
		height: '100%',
		width: '100%',
		position: 'absolute',
	},
	recommendedSlider__card__date: {
		zIndex: 2,
		fontSize: 16,
		position: 'absolute',
		top: 0,
		right: 0,
		color: colors.yellow,
		textTransform: 'uppercase',
		fontFamily: 'Lato_700Bold',
		padding: 10,
	},
	recommendedSlider__card__time: {
		zIndex: 2,
		fontSize: 14,
		position: 'absolute',
		top: 20,
		right: 0,
		color: colors.white,
		textTransform: 'uppercase',
		fontFamily: 'Lato_400Regular',
		padding: 10,
	},
	recommendedSlider__card__artist: {
		zIndex: 2,
		fontSize: 22,
		position: 'absolute',
		bottom: -4,
		left: 0,
		color: colors.white,
		textTransform: 'uppercase',
		fontFamily: 'Lato_400Regular',
		padding: 10,

		color: colors.white,
		textTransform: 'uppercase',
		letterSpacing: -1,
	},
	recommendedSlider__card__venue: {
		zIndex: 2,
		fontSize: 16,
		position: 'absolute',
		bottom: 20,
		left: 0,
		color: colors.white,
		textTransform: 'uppercase',
		fontFamily: 'Lato_700Bold',
		padding: 10,
		fontSize: 12,
		color: '#dee2e6',
		textTransform: 'uppercase',
		letterSpacing: 1,
	},
});
